import * as React from "react";

import makeStyles from "@material-ui/styles/makeStyles";
import MuiDrawer from "@material-ui/core/Drawer";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import { SelectArrayInput } from "jazasoft";
import SimpleForm from "jazasoft/lib/mui/form/SimpleForm";

import { listFromCsv } from "../../../utils/helpers";
import SettingKeys from "../../../utils/SettingKeys";
import { useSetting } from "../../../hooks";

const useStyles = makeStyles(theme => ({
  drawerPaper: {
    maxWidth: 1000
  },
  drawerHeader: {
    display: "flex",
    width: 480,
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-start"
  },
  content: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    padding: "1.5em"
  },
  marginTop: {
    marginTop: "1.5em"
  }
}));

const OrderCloseDrawer = props => {
  const classes = useStyles();
  const { open, onOrderClose, onDrawerClose } = props;

  const fabricLeftoverReasons = useSetting(SettingKeys.REASON_FOR_FABRIC_LEFTOVER_FACTORY);
  const higherRecutReasons = useSetting(SettingKeys.REASON_FOR_HIGHER_RE_CUT);
  const higherEndBitsReasons = useSetting(SettingKeys.REASON_FOR_HIGHER_END_BITS_LEFTOVER);

  const choicesFabricLeftoverReasons = listFromCsv(fabricLeftoverReasons)?.map(e => ({ id: e, name: e }));
  const choicesHigherRecutReasons = listFromCsv(higherRecutReasons)?.map(e => ({ id: e, name: e }));
  const choicesHigherEndBitsReasons = listFromCsv(higherEndBitsReasons)?.map(e => ({ id: e, name: e }));

  const onSubmit = values => {
    onOrderClose && onOrderClose(values);
  };

  const title = "Closing Remarks";

  return (
    <MuiDrawer classes={{ paper: classes.drawerPaper }} anchor="right" open={open} onClose={onDrawerClose}>
      <div className={classes.drawerHeader}>
        <IconButton onClick={onDrawerClose}>
          <ChevronRightIcon />
        </IconButton>
        <div>
          <Typography variant="h5">{title}</Typography>
        </div>
      </div>
      <Divider />

      <div className={classes.content}>
        <SimpleForm onSubmit={onSubmit}>
          <SelectArrayInput source="fabricLeftover" label="Fabric Left Over Reason" choices={choicesFabricLeftoverReasons} />
          <SelectArrayInput source="higherRecut" label="Higher Recutting Reason" choices={choicesHigherRecutReasons} />
          <SelectArrayInput source="higherEndBits" label="Higher End Bits Reason" choices={choicesHigherEndBitsReasons} />
        </SimpleForm>
      </div>
    </MuiDrawer>
  );
};

export default OrderCloseDrawer;
